import tags from "../../../components/tags";
import { icons } from "../../../components/html";
import { statusCodes } from "../../../components/responses";

export default {
  "/user/friends": {
    get: {
      tags: [tags.sizeIdAccount],
      summary: "List of people paired with logged-in user",
      description: `${icons.u}
      If a user has their account connected to other users' accounts, returns list of those user profiles. The response can be filtered based on the specified query parameters.`,
      parameters: [
        { $ref: "#/components/parameters/acceptsLanguages" },
        { $ref: "#/components/parameters/userNameFilter" },
        { $ref: "#/components/parameters/gender" },
        { $ref: "#/components/parameters/limit" },
        { $ref: "#/components/parameters/offset" }
      ],

      responses: {
        "200": {
          content: {
            "application/json": {
              schema: {
                type: "array",
                items: {
                  $ref: "#/components/schemas/user"
                }
              }
            }
          }
        },
        ...statusCodes
      },
      security: [{ user: [] }]
    }
  }
};
